import React from "react";

import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";

import App from "./App";
import { DomainProvider } from "./context/DomainContext";
import { OptionProvider } from "./context/OptionContext";
import { QuotationListContextProvider } from "./context/QuotationListContext";
import { ThemeProvider } from "./context/ThemeContext";
import { UserProvider } from "./context/UserContext";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <DomainProvider>
        <UserProvider>
          <QuotationListContextProvider>
            <OptionProvider>
              <BrowserRouter>
                <App />
              </BrowserRouter>
            </OptionProvider>
          </QuotationListContextProvider>
        </UserProvider>
      </DomainProvider>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
